var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { property, state } from 'lit/decorators.js';
import { SlotController } from '../../controllers/slot-controller';
import { BlocksElement } from '../BlocksElement';
import '../card/card';
import '../text-link/text-link';
import styles from './header.styles';
/**
 * @slot skip-link - slot for custom skip link
 * @slot top - The header top
 * @slot default - The header default slot
 * @slot bottom - The header bottom
 * @csspart base - The component's base wrapper.
 * @csspart skip-link-card - The component's skip link card.
 * @csspart part-skip-link - The component's skip link.
 * @csspart skip-link-text-link - The component's skip link text..
 * @csspart top-wrapper - The component's top wrapper.
 * @csspart top-inner - The component's top inner.
 * @csspart part-top - The component's top slot.
 * @csspart middle-wrapper - The component's middle wrapper.
 * @csspart middle-container - The component's middle container.
 * @csspart middle-inner - The component's middle-inner wrapper.
 * @csspart part-default - The component's default slot.
 * @csspart bottom-wrapper - The component's bottom wrapper.
 * @csspart part-bottom - The component's bottom slot.
 */
export class BlocksHeader extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         * controls skip link visibility
         */
        this.showSkipLink = false;
        /**
         * skip link text
         */
        this.skipLinkText = 'Skip to Main Content';
        /**
         * tracks focus state of skip link
         */
        this.isSkipLinkActive = false;
        this.slots = new SlotController(this, 'top', 'bottom', 'skip-link', null);
    }
    static { this.styles = styles; }
    getSkipLinkTemplate() {
        return html `
      <slot part="part-skip-link" name="skip-link"></slot>
      <cat-text-link
        part="skip-link-text-link"
        exportparts=${this.getExportParts('text-link')}
        .href="${this.href}"
        .isSkipLink="${true}"
        @focus="${() => {
            this.isSkipLinkActive = true;
        }}"
        @blur="${() => {
            this.isSkipLinkActive = false;
        }}"
        >${this.skipLinkText}</cat-text-link
      >
    `;
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-header', {
            'cat-is-active': this.isActive === true,
            'cat-skip-link-active': this.isSkipLinkActive === true,
            'cat-c-header--has-top-slot': this.slots.hasSlotted('top'),
            'cat-c-header--has-bottom-slot': this.slots.hasSlotted('bottom'),
            'cat-c-header--has-skip-link-slot': this.slots.hasSlotted('skip-link')
        });
        return html `
      <header part="base" class="${componentClassName}">
        ${this.showSkipLink
            ? html ` <cat-card part="skip-link-card" exportparts=${this.getExportParts('card')} class="cat-c-header__skip-link">
              ${this.getSkipLinkTemplate()}
            </cat-card>`
            : nothing}
        <div part="top-wrapper" class="cat-c-header__top">
          <div part="top-inner" class="cat-c-header__top-inner">
            <slot part="part-top" name="top"></slot>
          </div>
        </div>
        <div part="middle-wrapper" class="cat-c-header__middle">
          <div part="middle-container" class="cat-c-header__middle-container">
            <div part="middle-inner" class="cat-c-header__middle-inner">
              <slot part="part-default"></slot>
            </div>
          </div>
        </div>
        <div part="bottom-wrapper" class="cat-c-header__bottom">
          <slot part="part-bottom" name="bottom"></slot>
        </div>
      </header>
    `;
    }
}
__decorate([
    property({ type: Boolean })
], BlocksHeader.prototype, "showSkipLink", void 0);
__decorate([
    property({ type: String })
], BlocksHeader.prototype, "skipLinkText", void 0);
__decorate([
    property({ type: String })
], BlocksHeader.prototype, "href", void 0);
__decorate([
    state()
], BlocksHeader.prototype, "isActive", void 0);
__decorate([
    state()
], BlocksHeader.prototype, "isSkipLinkActive", void 0);
if (customElements.get('cat-header') === undefined) {
    customElements.define('cat-header', BlocksHeader);
}
